import {lazy} from 'react';

export const InstituteSelectionLazy = lazy(() => import(/* webpackChunkName: "instituteSelection" */ '.'));
